import { appMethod as app } from '@utils/app';
import { getCurrentPageQueryParams } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './PreviewRowNumberOrder.less';

export default class PreviewRowNumberOrder extends OfficialPage {
  state = {
    calculationData: '',
    lineUpSettingData: ''
  }
  lineUpId = ''
  franchiseeId = ''

  constructor(props) {
    super(props);
    document.title = '确认支付';
  }

  componentWillMount(options = getCurrentPageQueryParams()) {
    this.lineUpId = options.detail
    this.franchiseeId = options.franchisee || ''
    this.dataInitial()
  }

  dataInitial = () => {
    this.getCalculationInfo()
    this.getLineUpSetting()
  }
  getCalculationInfo = () => {
    var _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/calculationPrice',
      method: 'post',
      data: {
        sub_shop_app_id: this.franchiseeId,
        line_up_type_id: this.lineUpId,
        is_balance: 0,
        selected_benefit: { no_use_benefit: 1 }
      },
      success: function (res) {
        var info = res.data
        _this.setData({
          calculationData: info
        })
      }
    })
  }
  getLineUpSetting = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppTostore/getTostoreLineUpSetting',
      data: {
        sub_app_id: that.franchiseeId
      },
      success: function (res) {
        that.setData({
          lineUpSettingData: res.data
        })
      }
    })
  }
  confirmOrder = event => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppTostore/addLineUpOrder',
      method: 'post',
      data: {
        line_up_type_id: that.lineUpId,
        formId: event.detail.formId,
        sub_app_id: that.franchiseeId,
        selected_benefit: that.data.selectDiscountInfo,
        is_balance: 0
      },
      success: function (res) {
        that.payOrder(res.data)
      },
      fail: function () {
        that.requesting = false
      },
      successStatusAbnormal: function () {
        that.requesting = false
      }
    })
  }
  payOrder = orderId => {
    var that = this
    function turnToRowNumOrderDetail() {
      app.turnToPage(
        '/orderMeal/pages/rowNumberOrderDetail/rowNumberOrderDetail?detail=' +
        orderId +
        (that.franchiseeId ? '&franchisee=' + that.franchiseeId : ''),
        1
      )
    }
    if (this.data.calculationData.price == 0) {
      app.sendRequest({
        url: '/index.php?r=AppShop/paygoods',
        data: {
          order_id: orderId,
          total_price: 0
        },
        success: function (res) {
          turnToRowNumOrderDetail()
        },
        fail: function () {
          turnToRowNumOrderDetail()
        },
        successStatusAbnormal: function () {
          turnToRowNumOrderDetail()
        }
      })
      return
    }
    // app.sendRequest({
    //   url: '/index.php?r=AppShop/GetWxWebappPaymentCode',
    //   data: {
    //     order_id: orderId
    //   },
    //   success: function (res) {
    //     var param = res.data
    //     param.orderId = orderId
    //     param.turnToRowNumOrderDetail = turnToRowNumOrderDetail
    //     param.goodsType = 0
    //     that.wxPay(param)
    //   },
    //   fail: function () {
    //     turnToRowNumOrderDetail()
    //   },
    //   successStatusAbnormal: function () {
    //     turnToRowNumOrderDetail()
    //   }
    // })
    app.goPay({
      orderId: orderId,
      franchisee: that.franchisee_id,
      successUrl: '/rowNumberOrderDetail?detail=' + orderId + (that.franchiseeId ? '&franchisee=' + that.franchiseeId : ''),
      cancel: '/rowNumberOrderDetail?detail=' + orderId + (that.franchiseeId ? '&franchisee=' + that.franchiseeId : ''),
    })
  }
  wxPay = param => {
    var that = this
    app.requestPayment({
      timeStamp: param.timeStamp,
      nonceStr: param.nonceStr,
      package: param.package,
      signType: param.signType,
      paySign: param.paySign,
      success: function (res) {
        app.wxPaySuccess(param)
        param.turnToRowNumOrderDetail()
      },
      fail: function (res) {
        if (res.errMsg === 'requestPayment:fail cancel') {
          app.showModal({
            content: '支付已取消',
            complete: function () {
              app.turnBack()
            }
          })
          return
        }
        app.showModal({
          content: '支付失败',
          complete: param.fail
        })
        app.wxPayFail(param, res.errMsg)
      }
    })
  }

  render() {
    const { lineUpSettingData, calculationData } = this.state
    return (
      <React.Fragment>
        <div className="official-page preview-row-number-order">
          <TopNav title="确认支付"/>
          <div className="row-number-header">
            <div className="shop-setting">
              <img src={lineUpSettingData.app_info && lineUpSettingData.app_info.app_logo} />
              <div>{lineUpSettingData.app_info && lineUpSettingData.app_info.app_name}</div>
            </div>
            <div>
              <span>排号费：</span>
              <span>{'¥' + lineUpSettingData.line_up_price}</span>
            </div>
          </div>
          <div className="row-number-contain">
            <div>
              {'排号类型：' + ((calculationData.line_up_data && calculationData.line_up_data.line_up_type_data.name) || '')}
            </div>
            <div>
              {'预计等待：' +
                ((calculationData.line_up_data && calculationData.line_up_data.line_up_count_info && calculationData.line_up_data.line_up_count_info[0]
                  .prepare_wait_time) > 0
                  ? (calculationData.line_up_data.line_up_count_info[0]
                    .prepare_wait_time > lineUpSettingData.max_display_time
                    ? '>' + lineUpSettingData.max_display_time
                    : calculationData.line_up_data.line_up_count_info[0]
                      .prepare_wait_time) + '分钟'
                  : '无需等待')}
            </div>
          </div>
          <div className="row-number-contain">
            <div>
              <span>实付金额：</span>
              <span>{'¥' + (calculationData.price || '')}</span>
            </div>
          </div>
          <form className="confirm-order-wrap">
            <button type="button" onClick={this.confirmOrder} className="comfirm-order">
              确认支付
            </button>
          </form>
        </div>
      </React.Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/preview-row-number-order/PreviewRowNumberOrder.jsx